<template>
  <div class="container">
    <p>米伯希招聘网 — 连接人才与机遇</p>
    <p>若有疑问请联系 Dy1848431227@outlook.com</p>
    <p>© 2026 米伯希招聘网 版权所有</p>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.886);
  color: white;
  text-align: center;
  justify-content: center;
  font-size: 14px;
  p{
    margin: 3px 0;
  }
}

</style>